import React from 'react';
import PropTypes from 'prop-types';
import { getDynamicClasses } from '../../utils';
import './styles.scss';
import TrackedButton from '../Buttons/TrackedButton';

const propTypes = {
  onClose: PropTypes.func,
  message: PropTypes.string,
  level: PropTypes.string,
};

const defaultProps = {
  onClose: () => {},
  message: '',
  level: 'warning',
};

class Alert extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      removed: false
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ open: false });
    setTimeout(() => {
      this.setState({ removed: true });
      this.props.onClose();
    }, 150);
  };

  render() {
    const { level, message } = this.props;
    let dynamicClasses = getDynamicClasses([
      [this.state.open, 'show', ''],
      [this.state.removed, 'minimize-height', '']
    ]);
    let dynamicClass = `alert-${level} ${dynamicClasses} mb-2`
    return (
      <div className={`alert alert-dismissible fade ${dynamicClass}`} role="alert">
        <TrackedButton
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
          onClick={this.handleClose}
          title="Close"
          action="Close banner alert"
        >
          <span aria-hidden="true">&times;</span>
        </TrackedButton>
        <span dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    );
  }
}

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

export default Alert;
